import React from 'react';
import { baseStyles } from '../styles';
import { CareMapprLayoutBasic } from '../../ai2/layout/Ai2Layout';

interface ErrorPageProps {
  pageKey: string;
}

const ErrorPage: React.FC<ErrorPageProps> = () => {
  const back = (): void => {
    window.history.back();
  };

  return (
    <CareMapprLayoutBasic noRedirect>
      <div className="ui offsetNavbar">
        <div style={{ padding: '7px 29px 7px 29px' }}>
          <div style={baseStyles.app}>
            <div style={baseStyles.centeredContainer}>
              <h3>Error</h3>
              <br></br>
              <div>
                <p>
                  Oops.. There was an error accessing data or you shouldn't be
                  here.
                </p>
                <p> </p>
                <button className="btn btnPrimary me-2" onClick={back}>
                  {' '}
                  Go back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CareMapprLayoutBasic>
  );
};

export { ErrorPage };
